import apiFetch from '../../common/apiFetch';
import { extractBase64FromDataUrl, getImageDimensions } from './utils';
import { ImageResult } from './eraseContent';

export interface OutpaintImageContentParams {
	imageBase64: string
	left?: number
	right?: number
	up?: number
	down?: number
	prompt?: string
	creativity?: number
	output_format: string
	targetWidth?: number
	targetHeight?: number
}

export const outpaintImageContent = async (params: OutpaintImageContentParams): Promise<ImageResult> => {
	let objectUrl: string | null = null;

	try {
		const response = await apiFetch('/ai-image-editor/outpaint', {
			method: 'POST',
			headers: {
				contentType: 'application/json'
			},
			body: JSON.stringify({
				image: extractBase64FromDataUrl(params.imageBase64),
				left: params.left ?? 0,
				right: params.right ?? 0,
				up: params.up ?? 0,
				down: params.down ?? 0,
				prompt: params.prompt ?? '',
				creativity: params.creativity ?? 0.5,
				output_format: params.output_format || 'png',
				targetWidth: params.targetWidth,
				targetHeight: params.targetHeight
			})
		});

		if (!response.ok) {
			const errorText = await response.text();
			throw new Error(`Failed to outpaint image: ${response.status} ${response.statusText} - ${errorText}`);
		}

		const resultBlob = await response.blob();
		objectUrl = URL.createObjectURL(resultBlob);

		const dimensions = await getImageDimensions(objectUrl);

		return {
			url: objectUrl,
			width: dimensions.width,
			height: dimensions.height,
			cleanup: () => {
				if (objectUrl) {
					URL.revokeObjectURL(objectUrl);
					objectUrl = null;
				}
			}
		};
	} catch (error) {
		if (objectUrl) {
			URL.revokeObjectURL(objectUrl);
		}
		throw error;
	}
}
